import { ACDLRoute, BaseRouteConfig } from './BaseRoute';

export class InferencesPath extends BaseRouteConfig {
  public readonly Index = 'evaluations';

  public readonly List = {
    Path: `${this.Path}/list`,
    All: new ACDLRoute<{ workspaceId: string }>(`${this.Path}/list/all`),
    Owned: new ACDLRoute<{ workspaceId: string }>(`${this.Path}/list/owned`),
    Others: new ACDLRoute<{ workspaceId: string }>(`${this.Path}/list/others`),
  };

  public readonly Details = {
    Path: `${this.Path}/:jobId`,
    Paths: new ACDLRoute<{ workspaceId: string; jobId: string; tab: string }>(`${this.Path}/:jobId/:tab`),
    Datasets: new ACDLRoute<{ workspaceId: string; jobId: string }>(`${this.Path}/:jobId/datasets`),
    Images: new ACDLRoute<{ workspaceId: string; jobId: string }>(`${this.Path}/:jobId/images`),
    PredictionInspector: new ACDLRoute<{ workspaceId: string; jobId: string; imageId: string }>(`${this.Path}/:jobId/images/:imageId`),
    Metrics: new ACDLRoute<{ workspaceId: string; jobId: string }>(`${this.Path}/:jobId/metrics`),
  };

  public readonly Create = {
    Path: `${this.Path}/create`,
    Paths: new ACDLRoute<{ workspaceId: string; tab: string }>(`${this.Path}/create/:tab`),
    Datasets: new ACDLRoute<{ workspaceId: string }>(`${this.Path}/create/datasets`),
    Images: new ACDLRoute<{ workspaceId: string }>(`${this.Path}/create/images`),
  };

  public readonly NotFound = {
    Path: `${this.Path}/not-found`,
  };
}
